var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',_vm._b({staticClass:"v-page",class:{ 'link-above': _vm.linkAbove }},'section',_vm.$attrs,false),[(_vm.background)?[_c('v-background',{attrs:{"src":_vm.background,"slideUpIn":_vm.slideUpIn}}),_c('section',{staticClass:"v-page-content"},[_vm._t("default")],2)]:[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }